import React from 'react';
import GrichSwap from './components/GrichSwap';
import './styles/styles.css';

function App() {
  return (
    <div className="App">
      <GrichSwap />
    </div>
  );
}

export default App;